/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { State } from '@/apps/appCreator/store';

type TDiscount = {
  keyName: string;
  value: number;
  selected: boolean;
};

type SliceState = {
  discounts: {
    [K: string]: {
      value: number;
      selected: boolean;
    };
  };
  tradeIn: {
    brand: string | undefined;
    model: string | undefined;
    initialPayment: boolean;
  };
};

const initialDiscounts = {
  resolvedTradeInDiscount: {
    value: 0,
    selected: false,
  },
  tradeInPrice: {
    value: 0,
    selected: false,
  },
  resolvedSuzukiFinanceDiscount: {
    value: 0,
    selected: false,
  },
  medicalDiscount: {
    value: 0,
    selected: false,
  },
  dealerDiscount: {
    value: 0,
    selected: false,
  },
};

const initialState: SliceState = {
  discounts: {
    ...initialDiscounts,
  },
  tradeIn: {
    brand: undefined,
    model: undefined,
    initialPayment: false,
  },
};

const carSlice = createSlice({
  name: 'carSlice',
  initialState,
  reducers: {
    updateDiscountSelected: (
      state,
      action: PayloadAction<Partial<TDiscount> & Pick<TDiscount, 'keyName'>>
    ) => {
      const { keyName, selected, ...rest } = action.payload;
      state.discounts[keyName] = {
        ...state.discounts[keyName],
        ...rest,
        selected:
          selected !== undefined ? selected : state.discounts[keyName].selected,
      };

      // выбираем выгоду трейд-ин, если выбрали расчетную стоимость trade-in
      if (keyName === 'tradeInPrice' && selected) {
        state.discounts.resolvedTradeInDiscount = {
          ...state.discounts.resolvedTradeInDiscount,
          selected: true,
        };
      }
    },
    clearDiscountsSelected: state => {
      state.discounts = {
        ...initialDiscounts,
      };
    },
    updateTradeInBrand: (state, action: PayloadAction<string | undefined>) => {
      state.tradeIn.brand = action.payload;
    },
    updateTradeInModel: (state, action: PayloadAction<string | undefined>) => {
      state.tradeIn.model = action.payload;
    },
    updateTradeInInitialPayment: (state, action: PayloadAction<boolean>) => {
      state.tradeIn.initialPayment = action.payload;

      /**
       * Если используем первоначальный взнос,
       * тогда устанавливаем выгоду trade-in и стоимость авто в true
       */
      if (action.payload) {
        state.discounts.resolvedTradeInDiscount.selected = true;
        state.discounts.tradeInPrice.selected = true;
      }
    },
  },
});

const selectState = (state: State) => state.car;
const selectDiscounts = (state: State) => state.car.discounts;
const selectTradeInCar = (state: State) => state.car.tradeIn;

const selectors = {
  selectState,
  selectDiscounts,
  selectTradeInCar,
};

const actions = {
  ...carSlice.actions,
};

export { carSlice as default, actions, selectors };
